import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import usePermission from "@app/context/PermissionContext";
import { RolesTypes } from "@app/pages/users/utils/helpers";
import { errorAlert } from "../alerts";

type Props = {
  children: ReactNode;
  permissions: RolesTypes[];
};

export const PrivateRoutes = ({ children, permissions }: Props) => {
  const { isAdmin, isSuperAdmin, isTechnical } = usePermission();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const userRoles = [
    isAdmin && RolesTypes.ADMIN,
    isSuperAdmin && RolesTypes.SUPER_ADMIN,
    isTechnical && RolesTypes.TECHNICAL,
  ].filter(Boolean) as RolesTypes[];

  const hasPermission = userRoles.some((role) => permissions.includes(role));

  useEffect(() => {
    if (!hasPermission && userRoles.length>0) {
      errorAlert("No tienes permisos para acceder a esta página");
      navigate(
        pathname === "/admin/usuarios"
          ? "/"
          : pathname.split("/").slice(0, 3).join("/")
      );
    }
  }, [hasPermission, pathname]);

  if (!hasPermission) return null;

  return <>{children}</>;
};
